import { apiClient } from "./client";

/**
 * Location data from BC API
 */
export interface BCLocation {
  "@odata.etag"?: string;
  id: string;
  code: string;
  displayName: string;
  contact: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  phoneNumber: string;
  email: string;
  website: string;
  lastModifiedDateTime: string;
}

/**
 * Response from BC locations API
 */
export interface LocationsResponse {
  "@odata.context"?: string;
  value: BCLocation[];
}

/**
 * Locations API endpoints
 */
export const locationsApi = {
  /**
   * Fetch all locations from BC
   */
  getAll: async (): Promise<LocationsResponse> => {
    const response = await apiClient.get<LocationsResponse>("/bc/locations");
    return response.data;
  },
};
